export enum StepsAction {
  SetCurrentStep = 'setCurrentStep',
}
